import { render, staticRenderFns } from "./CustomFieldsTabComponent.vue?vue&type=template&id=0da8d53b&scoped=true&lang=pug"
import script from "./CustomFieldsTabComponent.vue?vue&type=script&lang=ts"
export * from "./CustomFieldsTabComponent.vue?vue&type=script&lang=ts"
import style0 from "./CustomFieldsTabComponent.vue?vue&type=style&index=0&id=0da8d53b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8d53b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0da8d53b')) {
      api.createRecord('0da8d53b', component.options)
    } else {
      api.reload('0da8d53b', component.options)
    }
    module.hot.accept("./CustomFieldsTabComponent.vue?vue&type=template&id=0da8d53b&scoped=true&lang=pug", function () {
      api.rerender('0da8d53b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customFields/CustomFieldsTab/CustomFieldsTabComponent.vue"
export default component.exports